/* global global */

// Local imports
// polyfills must be applied before everything else
import '../../polyfill/index.js';

import * as donation_datalayer from '../../donation/datalayer.js';
import * as gccat_datalayer from './datalayer.js';
import * as gccat_card_datalayer from '../../gift_catalogue/datalayer/gccat.js';
import * as gc_featured_datalayer from '../../gift_catalogue/datalayer/gc_featuredproduct.js';
import * as gc_tabbed_datalayer from '../../gift_catalogue/datalayer/gc_tabbedproduct.js';
import * as gcnav_datalayer from '../../gift_catalogue/datalayer/gcnav.js';
import * as gtm_vars from '../../../component/datalayer/gtm/gtm_vars.js';
import * as gtm_push from '../../../component/datalayer/gtm/gtm_push.js';
import * as global_mod from '../../global/index.js';
import { PAGE_VARS, PageKind } from '../vars.js';
import * as sort_collection from '../../util/sort_collection.js';
import * as tealium from '../../datalayer/tealium.js';
import * as init_donation_datalayer from '../../datalayer/data/donation.js';
import * as featured_card_handler from '../../gift_catalogue/card/featured_card_handler.js';
import * as tabbed_card_handler from '../../gift_catalogue/card/tabbed_card_handler.js';

import * as shopify_data from './shopify_data.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'gccategory';

export let global_vars = {};

// --------------------------------------------------------------------------
// Functions
// --------------------------------------------------------------------------

class ShopifyData {
    constructor(data_element) {
        this.data_element = data_element;
    }

    product_data() {
        let all_product = this.data_element.querySelectorAll('.product');
        for (let product of all_product) {
            let data = product.dataset;

            shopify_data.save_gccat_card_data(
                // Product
                {
                    id: data.id,
                    title: data.title,
                    price: data.price,
                    img_url: data.img_url,
                },

                data.ispromo,
                data.position,

                // list_name
                'Gift Products List',

                // collection_title
                `Gifts/${data.collection_title}`
            );
        }
    }

    general_data() {
        let all_general = this.data_element.querySelectorAll('.general');
        for (let general of all_general) {
            let data = general.dataset;

            let product = {
                id: data.id,
                title: data.title,
                price: data.price,
                variants: data.variants,
            };

            shopify_data.save_general_data(
                product,

                // category name
                'Donations',

                data.ispromo,
                data.img_url
            );
        }
    }

    run() {
        this.product_data();
        this.general_data();
    }
}

function process_shopify_data(global) {
    const SHOPIFY_DATA = shopify_data.SHOPIFY_DATA;

    let data_element = global.document.getElementById('gccategory-data');
    let shpdata = new ShopifyData(data_element);
    shpdata.run();

    // Cards
    for (let d of SHOPIFY_DATA.card) {
        gccat_datalayer.update_card_datalayer(
            d.product,
            d.ispromo,
            d.position,
            d.list_name,
            d.collection_title
        );
    }

    // General donation
    for (let d of SHOPIFY_DATA.general) {
        donation_datalayer.update_datalayer(
            d.product,
            d.category,
            d.ispromo,
            d.img_url
        );
    }
}

function init_pagevars() {
    PAGE_VARS.kind = PageKind.GiftCatalogue;
}

function initialize(global) {
    process_shopify_data(global);
}

export function main() {
    // Initialize all page vars
    init_pagevars();

    // Create object to pass to global initialization
    // init_donation_datalayer will initialize donation datalayer after the gc
    // datalayer has been initialized
    let all_modules = [init_donation_datalayer];
    all_modules.push.apply(all_modules, global_mod.__all__);

    let gccat_mod = {
        MODULE_NAME,
        global_vars,
        initialize,
    };

    all_modules.push(
        sort_collection,
        gccat_mod,
        featured_card_handler,
        tabbed_card_handler,
        gtm_vars,
        gcnav_datalayer,
        gccat_card_datalayer,
        gc_featured_datalayer,
        gc_tabbed_datalayer,
        gtm_push
    );

    // Insert datalayer setup module and tealium module at the beginning and end
    // of the modules array respectively
    all_modules = tealium.wrap_module_array(all_modules);

    // Initialize globals
    // The ``global`` global variable will be ``window`` when run in a browser
    // context.
    global_mod.initialize(global, all_modules);
}
